/**
 * Handles state of news
 */
import { GET_NEWS, SET_NEWS } from '../actions/news';

export interface INewsItem {
  id: number;
  title: string;
  text: string;
  placement: number | null;
  btn_color?: string;
  image_url?: string;
  link?: string;
}

export interface INewsState {
  items: INewsItem[];
  loading: boolean;
}

const initialState = {
  items: [],
  loading: true,
};

const newsReducer = (state: INewsState = initialState, action: any) => {
  switch (action.type) {
  case GET_NEWS: return {
    items: [],
    loading: true,
  };
  case SET_NEWS:
    return {
      items: action.payload,
      loading: false
    };
  default:
    return state;
  }
};

export default newsReducer;
